import * as account from './account';
import * as assignment from './assignment';
import * as authorization from './authorization';
import * as firebaseDevice from './firebaseDevice';
import * as integretion from './integration';

export const api = { account, assignment, authorization, firebaseDevice, integretion };
